import type { Localized } from '../types'

type CopyMap = Record<string, Localized>

export const copy: CopyMap = {
  announcement: {
    en: 'Professional Deep Cleaning • Same-Day Service • Se Habla Español',
    es: 'Limpieza Profunda Profesional • Servicio el Mismo Día • Se Habla Español',
  },
  tagline: {
    en: 'Professional Deep Cleaning & Residential Services',
    es: 'Limpieza Profunda Profesional y Servicios Residenciales',
  },

  navHome: { en: 'Home', es: 'Inicio' },
  navServices: { en: 'Services', es: 'Servicios' },
  navGallery: { en: 'Gallery', es: 'Galería' },
  navAbout: { en: 'About', es: 'Nosotros' },
  navFaq: { en: 'FAQ', es: 'Preguntas' },
  navContact: { en: 'Contact', es: 'Contacto' },
  navBook: { en: 'Book Cleaning', es: 'Reservar Limpieza' },
  navMenu: { en: 'Open menu', es: 'Abrir menú' },
  navClose: { en: 'Close menu', es: 'Cerrar menú' },
  langToggle: { en: 'Switch to Spanish', es: 'Cambiar a inglés' },

  heroTitle: {
    en: 'Your Home Deserves Professional Care',
    es: 'Su Hogar Merece Cuidado Profesional',
  },
  heroSubtitle: {
    en: 'Expert deep cleaning for your home • Trusted by 500+ families • Free estimates • Same-day service available',
    es: 'Limpieza profunda experta para su hogar • Más de 500 familias confían en nosotros • Estimados gratis • Servicio el mismo día',
  },
  heroPrimaryCta: { en: 'Schedule Free Estimate', es: 'Agendar Estimado Gratis' },
  heroSecondaryCta: { en: 'Call', es: 'Llamar' },
  badgeTeam: { en: 'Professional Team', es: 'Equipo Profesional' },
  badgeGuarantee: { en: '100% Satisfaction Guaranteed', es: '100% Satisfacción Garantizada' },
  badgeEco: { en: 'Eco-Friendly Products', es: 'Productos Ecológicos' },
  badgeSpanish: { en: 'Se Habla Español', es: 'Se Habla Español' },

  mascotKicker: { en: 'Meet our cleaning expert', es: 'Conozca a nuestra experta' },
  mascotTitle: {
    en: 'Here to make your home sparkle',
    es: 'Aquí para hacer brillar su hogar',
  },
  mascotBody: {
    en: 'Every visit is handled by a trained, background-checked professional who treats your home like their own — arriving on time, in uniform, with everything needed to get it done right.',
    es: 'Cada visita la realiza un profesional capacitado y verificado que cuida su hogar como el propio: llega a tiempo, con uniforme y con todo lo necesario para hacerlo bien.',
  },
  mascotStatYears: { en: 'Years of experience', es: 'Años de experiencia' },
  mascotStatFamilies: { en: 'Families served', es: 'Familias atendidas' },
  mascotStatBilingual: { en: 'Bilingual team', es: 'Equipo bilingüe' },

  servicesKicker: { en: 'Our Services', es: 'Nuestros Servicios' },
  servicesTitle: { en: 'Cleaning Built Around Your Home', es: 'Limpieza Adaptada a Su Hogar' },
  servicesSubtitle: {
    en: 'Transparent pricing, clear scope, and a professional crew for every room in the house.',
    es: 'Precios transparentes, alcance claro y un equipo profesional para cada área de la casa.',
  },
  bookNow: { en: 'Book Now', es: 'Reservar' },
  viewAllServices: { en: 'View All Services', es: 'Ver Todos los Servicios' },
  includes: { en: 'Includes', es: 'Incluye' },
  popular: { en: 'Most requested', es: 'Más solicitado' },

  whyKicker: { en: 'Why 3D Cleaning', es: 'Por Qué 3D Cleaning' },
  whyTitle: { en: 'Why Houston Families Choose Us', es: 'Por Qué Nos Eligen en Houston' },

  stepsKicker: { en: 'How It Works', es: 'Cómo Funciona' },
  stepsTitle: { en: 'Three Steps to a Spotless Home', es: 'Tres Pasos a un Hogar Impecable' },

  galleryKicker: { en: 'Gallery', es: 'Galería' },
  galleryTitle: { en: 'See Our Amazing Transformations', es: 'Vea Nuestras Transformaciones' },
  gallerySubtitle: {
    en: 'Explore our favorite transformations — each project shows our commitment to quality and detail.',
    es: 'Explore nuestras transformaciones favoritas: cada proyecto muestra nuestro compromiso con la calidad y el detalle.',
  },
  galleryCtaTitle: {
    en: 'Ready to See Your Home Transform?',
    es: '¿Listo para Ver Su Hogar Transformado?',
  },
  galleryCtaSubtitle: {
    en: 'Get a professional deep cleaning today — same-day service available in Houston.',
    es: 'Reciba una limpieza profunda profesional hoy: servicio el mismo día disponible en Houston.',
  },
  galleryCtaPrimary: { en: 'Book Your Cleaning', es: 'Reserve Su Limpieza' },
  galleryCtaSecondary: { en: 'Learn More Services', es: 'Ver Más Servicios' },
  galleryAll: { en: 'All', es: 'Todo' },
  galleryDrag: { en: 'Drag to compare', es: 'Arrastre para comparar' },
  galleryExpand: { en: 'Expand', es: 'Ampliar' },
  galleryBefore: { en: 'Before', es: 'Antes' },
  galleryAfter: { en: 'After', es: 'Después' },
  galleryCloseLightbox: { en: 'Close image viewer', es: 'Cerrar el visor de imágenes' },
  gallerySliderLabel: { en: 'Before and after comparison', es: 'Comparación de antes y después' },

  testimonialsKicker: { en: 'Reviews', es: 'Reseñas' },
  testimonialsTitle: { en: 'What Our Happy Customers Say', es: 'Lo Que Dicen Nuestros Clientes' },
  testimonialPrev: { en: 'Previous review', es: 'Reseña anterior' },
  testimonialNext: { en: 'Next review', es: 'Reseña siguiente' },

  extrasKicker: { en: 'Extra Services', es: 'Servicios Extra' },
  extrasTitle: {
    en: 'Additional Services',
    es: 'Servicios Adicionales',
  },
  extrasSubtitle: {
    en: 'Make your home even more comfortable, clean and organized. Add any of these to your booking.',
    es: 'Haga su hogar aún más cómodo, limpio y organizado. Agregue cualquiera a su reserva.',
  },

  aboutKicker: { en: 'About Us', es: 'Sobre Nosotros' },
  aboutTitle: { en: 'A Family-Owned Houston Cleaning Company', es: 'Una Empresa Familiar de Houston' },
  aboutBody: {
    en: 'For more than ten years, 3D Cleaning Services has cleaned Houston homes and offices with the same standard we hold for our own family. We are fully licensed and insured, we bring our own professional-grade supplies, and we do not leave until the work meets our checklist — and yours.',
    es: 'Por más de diez años, 3D Cleaning Services ha limpiado casas y oficinas en Houston con el mismo estándar que aplicamos en nuestro propio hogar. Contamos con licencia y seguro, traemos nuestros propios productos profesionales y no nos vamos hasta cumplir nuestra lista de verificación y la suya.',
  },
  aboutImageAlt: {
    en: 'The 3D Cleaning Services team in blue uniforms inside a bright Houston living room',
    es: 'El equipo de 3D Cleaning Services con uniformes azules en una sala luminosa de Houston',
  },

  areaKicker: { en: 'Service Area', es: 'Área de Servicio' },
  areaTitle: { en: 'We Service Houston & Surrounding Areas', es: 'Servimos Houston y Áreas Cercanas' },
  areaBody: {
    en: 'Available throughout Houston and nearby communities, within a 20–30 mile service radius. Not sure if you are covered? Call or text us and we will confirm in minutes.',
    es: 'Disponibles en todo Houston y comunidades cercanas, en un radio de servicio de 20 a 30 millas. ¿No sabe si cubrimos su zona? Llame o escriba y lo confirmamos en minutos.',
  },
  areaMapTitle: { en: 'Map of the Houston service area', es: 'Mapa del área de servicio de Houston' },
  areaRadius: { en: '20–30 mile service radius', es: 'Radio de servicio de 20 a 30 millas' },
  areaHours: { en: 'Mon–Sat 8am–6pm · Sun by appointment', es: 'Lun–Sáb 8am–6pm · Dom con cita' },

  faqKicker: { en: 'FAQ', es: 'Preguntas' },
  faqTitle: { en: 'Frequently Asked Questions', es: 'Preguntas Frecuentes' },

  formKicker: { en: 'Booking', es: 'Reservas' },
  formTitle: { en: 'Schedule Your Cleaning Today', es: 'Agende Su Limpieza Hoy' },
  formSubtitle: { en: 'Fill out the form or call us directly', es: 'Complete el formulario o llámenos directamente' },
  formName: { en: 'Full name', es: 'Nombre completo' },
  formPhone: { en: 'Phone number', es: 'Número de teléfono' },
  formEmail: { en: 'Email (optional)', es: 'Correo electrónico (opcional)' },
  formService: { en: 'Service type', es: 'Tipo de servicio' },
  formHomeSize: { en: 'Home size', es: 'Tamaño del hogar' },
  formDate: { en: 'Preferred date', es: 'Fecha preferida' },
  formTime: { en: 'Preferred time', es: 'Hora preferida' },
  formRequests: { en: 'Special requests', es: 'Solicitudes especiales' },
  formRequestsPlaceholder: {
    en: 'Pets at home, areas to focus on, parking notes…',
    es: 'Mascotas en casa, áreas prioritarias, notas de estacionamiento…',
  },
  formSubscribe: { en: 'Subscribe to cleaning tips', es: 'Recibir consejos de limpieza' },
  formSubmit: { en: 'Request Estimate', es: 'Solicitar Estimado' },
  formSubmitting: { en: 'Sending…', es: 'Enviando…' },
  formSelect: { en: 'Select an option', es: 'Seleccione una opción' },
  formRequired: { en: 'Required', es: 'Requerido' },
  formNameError: { en: 'Please enter your full name.', es: 'Por favor ingrese su nombre completo.' },
  formPhoneError: { en: 'Please enter a valid phone number.', es: 'Por favor ingrese un teléfono válido.' },
  formServiceError: { en: 'Please choose a service.', es: 'Por favor elija un servicio.' },
  formErrorSummary: {
    en: 'Please fix the highlighted fields and try again.',
    es: 'Corrija los campos señalados e intente de nuevo.',
  },
  formSuccessTitle: { en: 'Request received', es: 'Solicitud recibida' },
  formSuccessBody: {
    en: 'Thank you! We will call or text you within one business hour to confirm your estimate.',
    es: '¡Gracias! Le llamaremos o escribiremos dentro de una hora hábil para confirmar su estimado.',
  },
  formSuccessAgain: { en: 'Send another request', es: 'Enviar otra solicitud' },
  orReachUs: { en: 'Reach us directly', es: 'Contáctenos directamente' },
  callPerson: { en: 'Call', es: 'Llamar a' },
  emailLabel: { en: 'Email', es: 'Correo' },
  sameDay: { en: 'Same-day service available', es: 'Servicio el mismo día disponible' },

  whatsappUs: { en: 'WhatsApp us', es: 'Escríbanos por WhatsApp' },
  whatsappBubble: { en: 'WhatsApp us', es: 'WhatsApp' },
  callUs: { en: 'Call us', es: 'Llámenos' },
  dismissBubble: { en: 'Dismiss message', es: 'Descartar mensaje' },

  footerAbout: {
    en: 'Professional cleaning services in Houston',
    es: 'Servicios de limpieza profesional en Houston',
  },
  footerQuickLinks: { en: 'Quick Links', es: 'Enlaces Rápidos' },
  footerServices: { en: 'Services', es: 'Servicios' },
  footerContact: { en: 'Contact & Hours', es: 'Contacto y Horario' },
  footerHours: { en: 'Hours', es: 'Horario' },
  footerRights: { en: 'All rights reserved.', es: 'Todos los derechos reservados.' },
  privacy: { en: 'Privacy Policy', es: 'Política de Privacidad' },
  terms: { en: 'Terms of Service', es: 'Términos de Servicio' },
}
